export default __webpack_public_path__ + "static/media/logoWhite.48480bb0.png";